import React from "react";
import { Typography } from "@/components/Typography";
import { ShareButton } from "@npm_leadtech/share-button";
import { IoShareSocial } from "react-icons/io5";

import type { CouponHeaderProps } from "./types";

export const CouponHeader = ({ companyName }: CouponHeaderProps) => {
  return (
    <div className="coupon-template__header">
      <Typography Tag="p">{companyName}</Typography>
      <ShareButton icon={<IoShareSocial />} />
    </div>
  );
};
